import Vue from 'vue'
import Router from 'vue-router'
import Store from './store'
import { FUNCTION_TYPE } from '@/constants.js'

import theLogin from './views/login/TheLogin.vue'
import theMultiFactorAuth from './views/login/TheMultiFactorAuth.vue'
import theDashBoard from './views/TheDashBoard.vue'
import theMemberDispatch from './views/TheMemberDispatch.vue'
import theList from './views/TheList.vue'
import theReport from './views/TheReport.vue'
import thePlace from './views/ThePlace.vue'
import theStatus from './views/TheStatus.vue'
import theCheckin from './views/TheCheckin.vue'
import theMessage from './views/TheMessage.vue'
import theAnalyze from './views/TheAnalyze.vue'
import theSample from './views/TheSample.vue'
// import theOAuth2Login from './views/login/TheOAuth2Login.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASEURL,
  routes: [
    //ログインページ
    {
      path: '/login',
      name: 'login',
      component: theLogin,
      props: (route) => ({ redirectToken: route.query.redirect_token }),
    },
    //多要素認証ページ
    {
      path: '/multi-factor-auth',
      name: 'multi-factor-auth',
      component: theMultiFactorAuth,
      props: (route) => ({ redirectToken: route.query.redirect_token }),
    },
    //ダッシュボードページ
    {
      path: '/',
      name: 'dashboard',
      meta: {
        requiresAuth: true, //要認証
      },
      component: theDashBoard,
    },
    // 地図ページ
    {
      path: '/member',
      name: 'member',
      meta: {
        requiresAuth: true, //要認証
      },
      component: theMemberDispatch,
      props: true,
    },
    // リストページ
    {
      path: '/list',
      name: 'list',
      meta: {
        requiresAuth: true, //要認証
      },
      component: theList,
    },
    //報告書ページ
    {
      path: '/report',
      name: 'report',
      meta: {
        requiresAuth: true, //要認証
        functionType: FUNCTION_TYPE.REPORT,
      },
      component: theReport,
      props: true,
    },
    //プレイスページ
    {
      path: '/place',
      name: 'place',
      meta: {
        requiresAuth: true, //要認証
        functionType: FUNCTION_TYPE.PLACE,
      },
      component: thePlace,
      props: { placeLimit: 100 },
    },
    //ステイタスページ
    {
      path: '/status',
      name: 'status',
      meta: {
        requiresAuth: true, //要認証
        functionType: FUNCTION_TYPE.STATUS,
      },
      component: theStatus,
    },
    //チェックインページ
    {
      path: '/checkin',
      name: 'checkin',
      meta: {
        requiresAuth: true, //要認証
        functionType: FUNCTION_TYPE.CHECKIN,
      },
      component: theCheckin,
    },
    //メッセージページ
    {
      path: '/message',
      name: 'message',
      meta: {
        requiresAuth: true, //要認証
        functionType: FUNCTION_TYPE.SEND_MESSAGE,
      },
      component: theMessage,
    },
    //分析ページ
    {
      path: '/analyze',
      name: 'analyze',
      meta: {
        requiresAuth: true, //要認証
        functionType: FUNCTION_TYPE.ANALYZE,
      },
      component: theAnalyze,
      props: true,
    },
    // // OAuth2 Login (関連)
    // {
    //   path: '/oauth2',
    //   name: 'oauth2Login',
    //   meta: {
    //     requiresAuth: false,
    //   },
    //   component: theOAuth2Login,
    // },
    //サンプルページ
    {
      path: '/sample',
      name: 'sample',
      meta: {
        requiresAuth: true, //要認証
      },
      component: theSample,
    },
    /*--------------------------------------------------
     カスタマイズする場合は以下を追加していってください。
    {
      path: '/xxxxxx',
      name: 'xxxxxx',
      meta: {
        requiresAuth : true, ※認証が必要な場合は記述、不要な場合は削除
      },
      component: xxxxxxx ※importした際の名称をつけること
    },
    ---------------------------------------------------- */
  ],
})

/**
 * 機能タイプを持っていて遷移可能な場合はtrue
 * @param {Object} to routeオブジェクト(遷移先)
 * @returns {Boolean}
 */
const isAllowedToNavigateByFunctionType = (to) => {
  return to.matched.every((page) => {
    const type = page.meta.functionType
    return !type || !!Store.getters.functionType(type)
  })
}

/**
 * fullPath から指定のクエリだけを除く
 * @param {string} path RouteオブジェクトのfullPath
 * @param {string} key omitするqueryのkey
 * @returns {string} omitしたfullPath
 */
const omitParamFromFullPath = (path, key) => {
  const origin = new URL(location.href).origin
  const url = new URL(path, origin)
  url.searchParams.delete(key)
  return `${url.pathname}${url.search}`
}

//ページ切替前チェック処理
router.beforeEach((to, from, next) => {
  //ログインが必要なページかどうかチェック
  if (to.matched.some((page) => page.meta.requiresAuth)) {
    //ログインユーザーIDが空の場合はログインページへリダイレクト
    if (!Store.state.app.isReady) {
      next({
        path: '/login',
        query: {
          // 単純に to.fullpath を指定するとredirect_tokenがredirect先のパスの方に含まれてしまいトークンをログイン画面に渡せないので
          // redirect_tokenだけ分離する
          redirect: omitParamFromFullPath(to.fullPath, 'redirect_token'),
          redirect_token: to.query.redirect_token,
        },
      })
    } else {
      if (!isAllowedToNavigateByFunctionType(to)) {
        // 機能タイプを持っていないページは見られない
        next({ path: '/' })
      } else {
        next()
      }
    }
  } else {
    if (to.path == '/ifield/users/web/oauth2') {
      next({ path: '/oauth2', query: to.query })
    } else {
      next()
    }
  }
})

export default router
